import { whenAmazonTakt } from '@amzn/takt-utils';

export const logWithTakt = (context: unknown, details: unknown): void => {
  if (window && (window as any).AmazonTakt) {
    (window as any).AmazonTakt.logCustom({
      context,
      details: JSON.stringify(details),
    });
  }
};

export const logMetadata = (metadata: unknown): void => {
  if (window && (window as any).AmazonTakt) {
    (window as any).AmazonTakt.addVisitMetadata(metadata);
  }
};

export const markComponentStart = (component: string): void => {
  whenAmazonTakt((amazonTakt) => {
    amazonTakt.waitForComponentsReady('AACChrome', [component]);
    amazonTakt.markComponentReady(
      component,
      amazonTakt.ComponentReadyState.START,
    );
  });
};

export const markComponentReady = (component: string): void => {
  whenAmazonTakt((amazonTakt) => {
    amazonTakt.markComponentReady(
      component,
      amazonTakt.ComponentReadyState.READY,
    );
  });
};

export const initTakt = (): void => {
  whenAmazonTakt((amazonTakt) => {
    amazonTakt.markComponentReady(
      'AACChrome',
      amazonTakt.ComponentReadyState.START,
    );
  });
};

export const markAACChromeReady = (): void => {
  whenAmazonTakt((amazonTakt) => {
    amazonTakt.markComponentReady(
      'AACChrome',
      amazonTakt.ComponentReadyState.READY,
    );
  });
};
